<template>
  <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
    <v-row no-gutters>
      <v-col cols="12" md="1">
        <router-link
          :to="{ name: 'OverviewPage', hash: '#remainder-of-estate' }"
          class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
      <v-col cols="12" md="3" class="form-blurb">
        <h1>Remainder of Estate</h1>
        <p>
          Should any of the beneficiaries you appointed in the previous step
          predecease you, who would you like to get their share of the remainder
          of your estate? Add your beneficiares here and ensure the total
          percentage adds up to 100%
        </p>
      </v-col>
      <v-col cols="12" md="7" offset-md="1">
        <AssignSpecificPercentages
          :testator="testator"
          :existing-specific-percentages="
            testator.remainderOfEstate
              .alternativeDistributionSpecificPercentages
          "
          :distribution="testator.remainderOfEstate.distribution"
          :button-loading="buttonLoading"
          @submit="saveSpecificPercentages"
        />
      </v-col>
    </v-row>

    <ErrorSnackbar v-model="showError" />
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { PROCESS_ALTERNATIVE_DISTRIBUTION_SPECIFIC_PERCENTAGES_MUTATION } from '../../constants/graphql/remainder-of-estates';
  import AssignSpecificPercentages from './AssignSpecificPercentages';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'AlternativeDistributionSpecificPercentages',
    components: {
      AssignSpecificPercentages,
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        type: Object,
        required: true,
      },
    },
    created() {
      if (!this.testator.remainderOfEstate)
        this.$router.push('/remainder-of-estate/distribution');
    },
    methods: {
      saveSpecificPercentages({ specificPercentages, deletedRecordIds }) {
        this.buttonLoading = true;
        const alternativeDistributionSpecificPercentageInputs =
          this.specificPercentagesForMutation(specificPercentages);

        this.$apollo
          .mutate({
            mutation:
              PROCESS_ALTERNATIVE_DISTRIBUTION_SPECIFIC_PERCENTAGES_MUTATION,
            variables: {
              alternativeDistributionSpecificPercentageInputs,
              deletedRecordIds,
            },
            update: (
              cache,
              { data: { processAlternativeDistributionSpecificPercentages } }
            ) => {
              this.updateCache(
                cache,
                processAlternativeDistributionSpecificPercentages
              );
            },
          })
          .then(_response => {
            this.redirectToNext();
            this.buttonLoading = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      specificPercentagesForMutation(specificPercentages) {
        var specificPercentageInputs = [];
        for (const sp of specificPercentages) {
          var specificPercentageInput = {};
          specificPercentageInput.id = sp.id;
          specificPercentageInput.beneficiaryType = sp.beneficiaryType;
          specificPercentageInput.beneficiaryId = sp.beneficiaryId;
          specificPercentageInput.percentage = parseInt(sp.percentage);
          specificPercentageInput.remainderOfEstateId =
            this.testator.remainderOfEstate.id;

          specificPercentageInputs.push(specificPercentageInput);
        }

        return specificPercentageInputs;
      },
      updateCache(cache, processAlternativeDistributionSpecificPercentages) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testator.id },
        };
        const data = cache.readQuery(query);

        data.testator.remainderOfEstate.alternativeDistributionSpecificPercentages =
          processAlternativeDistributionSpecificPercentages;

        cache.writeQuery({ ...query, data: data });
      },
      redirectToNext() {
        this.$router.push({ name: 'FamilyObliteration' });
      },
    },
  };
</script>
